import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo_wTVision_white.png'


const _hoisted_1 = { class: "admin-dashboard" }
const _hoisted_2 = { class: "TriangleTop" }
const _hoisted_3 = { class: "TriangleVerticalTop" }
const _hoisted_4 = { class: "logo-container" }
const _hoisted_5 = { class: "BottomContainer" }
const _hoisted_6 = { class: "approvals" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "users" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "logo",
            src: _imports_0,
            alt: "Logo",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
          })
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "TriangleVerticalLine" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Admin Dashboard", -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Pending User Approvals", -1)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingUsers, (user) => {
            return (_openBlock(), _createElementBlock("li", {
              key: user.user_id
            }, [
              _createTextVNode(_toDisplayString(user.username) + " (" + _toDisplayString(user.email) + ") ", 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.approveUser(user.user_id))
              }, "Approve", 8, _hoisted_7),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.declineUser(user.user_id))
              }, "Decline", 8, _hoisted_8)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[4] || (_cache[4] = _createElementVNode("h3", null, "All Users", -1)),
        _createElementVNode("table", null, [
          _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Username"),
              _createElementVNode("th", null, "Email"),
              _createElementVNode("th", null, "Active"),
              _createElementVNode("th", null, "Admin"),
              _createElementVNode("th", null, "Reviewer"),
              _createElementVNode("th", null, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allUsers, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.user_id
              }, [
                _createElementVNode("td", null, _toDisplayString(user.username), 1),
                _createElementVNode("td", null, _toDisplayString(user.email), 1),
                _createElementVNode("td", null, _toDisplayString(user.isapproved ? 'Yes' : 'No'), 1),
                _createElementVNode("td", null, _toDisplayString(user.isadmin ? 'Yes' : 'No'), 1),
                _createElementVNode("td", null, _toDisplayString(user.isreviewer ? 'Yes' : 'No'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.toggleUserActive(user)),
                    class: _normalizeClass({'disable':user.username === _ctx.currentUser?.username})
                  }, _toDisplayString(user.isapproved ? 'Deactivate' : 'Activate'), 11, _hoisted_10),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.deleteUser(user.user_id)),
                    class: _normalizeClass({'disable':user.username === _ctx.currentUser?.username})
                  }, "Delete", 10, _hoisted_11),
                  (user.isapproved)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.toggleUserAdmin(user)),
                        class: _normalizeClass({'disable':user.username === _ctx.currentUser?.username})
                      }, _toDisplayString(user.isadmin ? 'Revoke Admin' : 'Make Admin'), 11, _hoisted_12))
                    : _createCommentVNode("", true),
                  (user.isapproved)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.toggleUserReviewer(user)),
                        class: _normalizeClass({'disable':user.username===_ctx.currentUser?.username})
                      }, _toDisplayString(user.isreviewer ? 'Revoke Reviewer' : 'Make Reviewer'), 11, _hoisted_13))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}